import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CommonService } from '../../../../shared/common.service';
import * as CryptoJS from 'crypto-js';
import { DirectorsbenefitsService } from './directorsbenefits.service';
import Swal from 'sweetalert2';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-directors-benefits',
  templateUrl: './directors-benefits.component.html',
  styleUrls: ['./directors-benefits.component.scss']
})
export class DirectorsBenefitsComponent implements OnInit {
 
  constructor(public commonService: CommonService, private router: Router, public formbuilder: FormBuilder, public benefitsService: DirectorsbenefitsService) {}
  isJump: any;
  benfitform: FormGroup;
  APPeriodId: any;
  NormalRoutng; boolean;

  ngOnInit() {
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.commonService.getIncomeStatementsHeaders();
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.commonService.getIncomeStatementsHeaders();
    this.commonService.getNotesData();
    this.createdirectorbenifts();
    this.clearfield();
    this.getdirectorbenfit(this.APPeriodId)
    if (localStorage.getItem("SubmitStatus") == "true")
      this.benfitform.disable()
  }

  createdirectorbenifts() {
    this.benfitform = this.formbuilder.group({
      APPeriodId: ['', []],
      DirectorsBenfitsId: ['', []],
      TextComment: ['', []],
      CreatedBy: ['', []],
    })
    this.isJump = localStorage.getItem('isJump');
  }
  clear: any
  clearfield() {
    debugger
    this.clear = this.commonService.clearAllFields.subscribe((data: boolean) => {
      if (data) {
        this.benfitform.reset()
      }
    })
  }
  save(){
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8)
    this.benfitform.controls['APPeriodId'].setValue(this.APPeriodId)
    this.benfitform.controls['CreatedBy'].setValue(localStorage.getItem("LoginuserId"))
    const formdata = this.benfitform.getRawValue();
    this.benefitsService.adddirectorsbenefits(formdata).subscribe((data: any) => {
      this.benfitform.markAsPristine();
      if (this.NormalRoutng)
        return true;
      var nextPage;
      nextPage = this.commonService.getNextNoteSelection("Directors’ benefits", this.commonService.NotesList)
      if (this.isJump == 'true')
        this.router.navigate(['/notes'])
      else if (nextPage == 'directors’benefits') {
        nextPage = this.commonService.getNextPageSelection("Notes", this.commonService.allPagesdata)
        this.router.navigate([nextPage]);
      }
      else {
        this.router.navigate([nextPage]);
      }
    })
  }

  getdirectorbenfit(APPeriodId) {
    this.APPeriodId = CryptoJS.AES.decrypt(localStorage.getItem("APPeriodId"), "APS").toString(CryptoJS.enc.Utf8);
    this.benefitsService.Getdirectorsbenefit(APPeriodId).subscribe((data: any) => {
      this.benfitform.patchValue(data)
    })
    this.commonService.getNotesData();
  }

  back() {
    debugger;
    this.benfitform.markAsPristine();
    var backpage;
    if (this.isJump == 'true')
      this.router.navigate(['/notes'])
    else {
      backpage = this.commonService.getBackSelection("Directors’ benefits", this.commonService.NotesList)
      this.router.navigate([backpage]);
    }
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    debugger;
    if (this.benfitform.dirty) {
      return Swal.fire({
        title: "Andica Accounts Production",
        html: "<span style='font-weight:900'>You have unsaved data.</span> <br>Do you want to save your changes before leaving?",
        icon: "warning",
        confirmButtonText: "Save Changes",
        showCancelButton: true,
        cancelButtonText: "Discard Changes",
        allowOutsideClick: false
      }).then((result) => {
        if (result.value) {
          this.NormalRoutng = true;
          this.save();
          return true;
        }
        else {
          return true;
        }
      })
    }
    else if (this.commonService.routeToCompanyList) {
      return true
    }
  }

  TotalBack() {
    debugger;
    this.commonService.DisplayAccountingPeriodlist = true;
    this.router.navigate(['/business']);

  }





}
